import React from "react";

interface TabNavProps {
  active: string;
  tabs: string[];
  onSelect: (tab: string) => void;
}

const TabNav: React.FC<TabNavProps> = ({ active, tabs, onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4 border-b border-gray-200">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onSelect(tab)}
          className={`px-5 py-2 -mb-[1px] font-semibold transition-all duration-150
            ${
              active === tab
                ? "border-b-4 border-[#AA232F] bg-white text-[#AA232F] shadow"
                : "border-b-4 border-transparent bg-gray-100 text-gray-700 hover:bg-gray-200"
            }
            rounded-t-md
          `}
          style={{ minWidth: 120 }}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default TabNav;
